import workspaceService from '@/services/workspace.service';
import commonService from '@/services/common.service';
import config from '@/config/prod.env';

const actions = {
    async getAllWorkspace({ dispatch }) {
        return await workspaceService.getAll();
    },
    
    async getAllWorkspacePaging({ dispatch }, params) {
        return await workspaceService.getAllPaging(params);
    },

    // async getWorkspaceByUserId({ dispatch }, userId) {
    //     return await workspaceService.getByUserId(userId);
    // },

    async getWorkspaceByRoleIds({ dispatch }, roleIds) {
        return await workspaceService.getByRoleIds(roleIds);
    },

    async getWorkspaceById({ dispatch }, id) {
        return await workspaceService.getById(id);
    },
    
    async createWorkspace({ dispatch, commit }, workspace) {
        // upload image
        let uploadImageRes = null;
        if(workspace.localImage) {
            uploadImageRes = await commonService.uploadFile(workspace.localImage);
            workspace.operatingCenterLogo = uploadImageRes.data.data;
        }

        let res = await workspaceService.create(workspace);
        if(res.isOk) {
            if(res.data.data && res.data.data.id && res.data.data.id.trim().length > 0) {
                dispatch("alert/success", "Thêm mới thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async updateWorkspace({ dispatch, commit }, workspace) {
        let uploadImageRes = null;
        if(workspace.isChangedImage) {
            // remove old image
            await commonService.deleteFile(workspace.operatingCenterLogo);

            if(workspace.localImage === null) {
                workspace.operatingCenterLogo = "";
            } else {
                uploadImageRes = await commonService.uploadFile(workspace.localImage);
                workspace.operatingCenterLogo = uploadImageRes.data.data;
            }
        }

        let res = await workspaceService.update(workspace);
        if(res.isOk) {
            if(res.data.data) {
                dispatch("alert/success", "Cập nhật thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async deleteWorkspace({ dispatch, commit }, id) {
        let res = await workspaceService.delete(id);
        if(res.isOk) {
            if(res.data.data) {
                dispatch("alert/success", "Xóa thành công", { root: true });
                return true;
            } else {
                dispatch("alert/error", res.data.message, { root: true });
                return false;
            }
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

};

export const workspace = {
    namespaced: true,
    actions
};